module.exports = __webpack_public_path__ + "img/burguer.90db1885.jpg";